import {configureStore} from "@reduxjs/toolkit";
import userSlice from "../slices/userSlices";
import eventSlice from "../slices/eventSlices";
import teamSlice from "../slices/teamSlices";
import quizSlice from "../slices/quizSlices";


const store = configureStore({
    reducer : {
        users : userSlice,
        event : eventSlice,
        quiz : quizSlice,
        team : teamSlice,
    },

    middleware : (getDefaultMiddleware) =>getDefaultMiddleware({serializableCheck : false}),
});

export default store;

